module.exports = __webpack_public_path__ + "img/symbol_7.d12f5643.png";